import util from '../util'

let controller = 'OperadorRetaguardaParceiro'
export default Object.assign({}, util.GetCrud(controller, null), {
})



